
const state = {
  /* 标题 */
  pageTitle: '落地页',
  /* 自定义链接 */
  pageUrl: '',
  // 屏幕类型
  screenType: 'vertical',
  // 横屏是否生效
  effectH: 0,
  // 控制保存时的弹框，横竖屏切换时用到
  saveShowModal: false,
  /* 页面描述 */
 // pageDescContent: 'hello scaffold',
  /* 手机模板头图是否显示 true显示 false隐藏 */
  topImgShow: false,
  /* 详情图片数组 用于往服务器上传 */
  topImgFileList: [],
  topImgName: '',
  /* 嵌码 */
  embedCode: {
    codeUrl: '',
    codeContent: '',
    embedCodeEffective: ''
  },
  // 用于比较嵌码时用
  embedCodeSave: {
    codeUrl: '',
    codeContent: '',
    embedCodeEffective: ''
  },
  isDisable: false,
  // 倒计时
  countDown: {
    endTime: '', showEndTime: 0, countStyle: 0, bgRadio: 0, bgColor:'#000000', bgImg: '',fontPosition: 0, fontSize: 14, fontColor: '#ffffff'
  },
  hideCount: true,
  // 腾讯免流激活入口
  tAEntrance: {
    place: 1,wHeight: 200,showType: 2,bgColor: '#000000',fontColor: '#ffffff',
    font1: '免流中 流量详情', font2: '已有王卡 登录激活', font3: '',
    img1: '', img2: '', img3: ''
  },
  // 腾讯免流模块展示
  tAShow: 1,
  // 公告
  tNotice: {
    bgColor: '#fff3cb',fontColor: '#a27733',
    font: 'XX产品将于近期停售，我们会在**月**日起下架产品，欢迎继续关注其他套餐，谢谢！'
  },
  topUploadType: 1
};

const mutations = {
  newIsDisable (state, msg) {
    state.isDisable = msg;
  },
  /* 标题 */
  newPageTitle (state, msg) {
    state.pageTitle = msg;
  },
  /* 自定义链接 */
  newPageUrl (state, msg) {
    state.pageUrl = msg;
  },
  // newPageDescContent (state, msg) {
  //   state.pageDescContent = msg;
  // },
  // 更新屏幕类型
  newScreenType(state, msg) {
    state.screenType = msg;
  },
  // 更新横屏是否生效
  newEffectH(state, msg) {
    state.effectH = msg;
  },
  // 更新保存时的弹出框状态
  newSaveShowModal(state, msg) {
    state.saveShowModal = msg;
  },
  /* 手机模板头图是否显示 true显示 false隐藏 */
  newTopImgShow (state, msg) {
    state.topImgShow = msg;
  },
  /* 详情图片数组 用于往服务器上传 */
  newTopImgFileList (state, msg) {
    state.topImgFileList = msg;
  },
  /* 头图图片名称 */
  newTopImgName (state, msg) {
    state.topImgName = msg;
  },
  /* 嵌码 */
  newEmbedCode (state, msg) {
    state.embedCode = msg;
  },
  // 用于比较嵌码时用
  newEmbedCodeSave (state, msg) {
    state.embedCodeSave = msg;
  },
  // 倒计时
  newCountDown (state, msg) {
    state.countDown = msg;
  },
  newHideCount (state, msg) {
    state.hideCount = msg;
  },
  // 腾讯免流激活入口
  newTAEntrance (state, msg) {
    state.tAEntrance = msg;
  },
  // 腾讯免流模块展示
  newTAShow (state, msg) {
    state.tAShow = msg;
  },
  // 公告
  newTNotice (state, msg) {
    state.tNotice = msg;
  },
  newTopUploadType (state, msg) {
    state.topUploadType = msg;
  },
};

export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/topImg.js